<template>
        <div
         
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            z-index: 990
          "
        >
   
          <div
            style="
              display: flex;
              width: 100%;
              height: 20px;
              z-index: 99999;
              background-color: #fff;
            "
          >
            <div
              v-for="m in months"
              :key="m.index"
              style="
                display: flex;
                justify-content: center;
                box-sizing: border-box;
                font-size: 12px;
                font-weight: bold;
                    color: #FF5722;
              "
              :style="{
                width: options.day_width * m.length + 'px',
                'min-width': options.day_width * m.length + 'px',
              }"
            >
              {{ m.name.toUpperCase() }}
            
            </div>
          </div>

          <div
            style="
              display: flex;
              width: 100%;
              z-index: 99999;
              height: 20px;
              background-color: #fff;
            "
          >
            <div
              v-for="day in days_number"
              :key="day"
              style="
                display: inline-block;
                box-sizing: border-box;
                font-size: 12px;
                text-align: center;
                font-weight: normal;
                margin-bottom: 2px;
  text-transform: capitalize;
              "
              :style="{
            
                width: options.day_width + 'px',
                left: day * options.day_width,
             'border-left':
                  options.from_start.add(day, 'days').day() == 1
                    ? '1px solid #d1d1d1'
                    : 'none'
              }"
            >
            
              {{ getDay(day).format("ddd") }}
              <span  :style="{'background-color' : getDay_FF(day) == ttoday() ? '#ff9573' : '',
                   'border-radius':
                  options.from_start.add(day, 'days').day() == 1
                    ? 'none'
                    : '3px',  
                  color: getDay_FF(day) == ttoday() ? '#fff!important' : (options.gray_days.includes(
                  options.from_start.add(day, 'days').day()
                )
                  ? 'inherit'
                  : 'inherit')
              }" style="    padding-right: 1px;
    padding-left: 2px;
">
                    {{ getDay(day).format("D") }}
                    </span>
              
               <div style="font-size: 9px;
    margin-top: 4px;
    user-select: none;">{{ getBackgroundTitle(options.from_start.add(day, 'days').format('YYYY-MM-DD')) }}</div> 
            </div>
          </div>
     

        </div>

</template>


<script>
import dayjs from "dayjs";
import "dayjs/locale/it";
export default {
  name: "gant-grid-header",
  props: ["months","days_number","options", "background_colors", "match_exact_color"],
  watch: {
    'options': function(){

    }
  },
    methods: {
    getBackgroundTitle(dateStr) {
      if (this.match_exact_color){
        return null;
      }
      if (!this.background_colors) return null;
      for (const bg of this.background_colors) {
        if (dateStr >= bg.start && dateStr <= bg.end) {
          return bg.name;
        }
      }
      return null;
    },
    getDay(index) {
      return this.options.from_start.add(index, "days");
    },
    getDay_FF(index) {
      return this.options.from_start.add(index, "days").format("YYYY-MM-DD");
    },
    ttoday(){
      return dayjs().format("YYYY-MM-DD");
    },
    scrollToDay(container){
      
      container.scrollTo(this.$refs.today[0].getBoundingClientRect().left - 200,0);
    
    }
  }
};
</script>

<style scoped>
.events-container {
  background: #f7f7f7;
  height: 200px;
  height: 100%;
  position: relative;
}

.event {
  z-index: 1;
  display: inline-block;
  background-color: #673ab7;
  color: #fff;
  position: absolute;
  border-radius: 3px;
  padding: 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

.event .event_drag {
  min-width: 10px;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
}

.hide {
  right: -320px !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>